export var E_PRESET;
(function (E_PRESET) {
    E_PRESET["FULL_SEARCH"] = "fullSearch";
    E_PRESET["TEAM"] = "team";
    E_PRESET["PRODUCT_CODE"] = "productCode";
    E_PRESET["LEGACY_PRODUCT_CODE"] = "legacyProductCode";
})(E_PRESET || (E_PRESET = {}));
export var E_TYPE_FILTER;
(function (E_TYPE_FILTER) {
    E_TYPE_FILTER["DATE_RANGE"] = "date-range";
    E_TYPE_FILTER["SELECT_LIST"] = "select-list";
    E_TYPE_FILTER["TEXT"] = "text";
    E_TYPE_FILTER["SEARCH"] = "search";
})(E_TYPE_FILTER || (E_TYPE_FILTER = {}));
export var E_OPERATOR;
(function (E_OPERATOR) {
    E_OPERATOR["EQUALS"] = "EQUALS";
    E_OPERATOR["CONTAINS"] = "CONTAINS";
    E_OPERATOR["BETWEEN"] = "BETWEEN";
})(E_OPERATOR || (E_OPERATOR = {}));
export var E_SORT_ORDER;
(function (E_SORT_ORDER) {
    E_SORT_ORDER["ASC"] = "ASC";
    E_SORT_ORDER["DESC"] = "DESC";
})(E_SORT_ORDER || (E_SORT_ORDER = {}));
// TYPE GUARDS
// Check for key startDate and endDate because startDate and endDate can be undefined
export var isDateRange = function (choiceValue) {
    return choiceValue !== undefined && !Array.isArray(choiceValue) &&
        Object.keys(choiceValue).findIndex(function (key) { return key === 'startDate'; }) !== -1 &&
        Object.keys(choiceValue).findIndex(function (key) { return key === 'endDate'; }) !== -1;
};
export var isComposedChoiceValue = function (query) {
    return query.OR !== undefined;
};
// TYPE GUARDS
export var isComposedChoices = function (choices) {
    return Array.isArray(choices) && choices.filter(function (c) { return isComposedChoiceValue(c); }).length === choices.length;
};
export var isFilterChoiceQueryValue = function (choiceValue) {
    return !Array.isArray(choiceValue);
};
